import React from 'react';
import { Form, Header, Message, Button, Icon } from 'semantic-ui-react';
import admHOC from './admHOC.js';

class AdmFormTags extends React.Component {

  render() {

    const { formValues, formFieldValidity, submitAttempted, keyEditable } = this.props;
    const disableButtons = this.props.processing || !formFieldValidity._form || !formValues.key;

    const fanoutObj = {
      parentPath: 'channels',
      child: null,
      endpoint: 'tagsSys',
      data: formValues.key
    };

    return (
      <Form as='form'
        error={!formFieldValidity._form}
        onReset={this.props.handleReset}
        onSubmit={ (e) => {
          this.props.handleSubmit('tags', e, []);
        }}>
        <Header dividing>
          <Icon name='tag'/>
          <Header.Content>Requirement Types</Header.Content>
          <Header.Subheader>Add, Edit or Delete</Header.Subheader>
        </Header>

        <Form.Input required name='key' label='Key'
          readOnly={!keyEditable}
          onChange={this.props.handleChange}
          error={!formFieldValidity.key && submitAttempted}
          value={formValues.key}
          placeholder='Key required, please choose on the left or click "add new"'
        />

        <Form.Input required name='name' label='Name'
          onChange={this.props.handleChange}
          error={!formFieldValidity.name && submitAttempted}
          value={formValues.name}
        />

        <Message error className='formMsg'>
          <Message.Header>You shall not pass!</Message.Header>
          <Message.List items={formFieldValidity._msgList} />
        </Message>

        <Button color='red' icon='trash' basic
          type='button'
          disabled={disableButtons}
          onClick={ (e) => this.props.confirmDeletion('tags', e, ['channels'], [fanoutObj]) }
        />

        <Button.Group >
          <Button
            basic
            color='grey'
            type='reset'>
            Reset Form
          </Button>
          <Button
            primary
            disabled={disableButtons}
            type='submit'
            >
            Submit
          </Button>
        </Button.Group>

      </Form>
    );
  }

}

export default admHOC(AdmFormTags);



// WEBPACK FOOTER //
// ./src/components/forms/AdmFormTags.js